import type { AutocompleteResult } from 'src/types/map-provider';

import { Box } from '@mui/material';

import { UniversalAutocompleteField } from '../universal-autocomplete-field';
import { SEARCH_OVERLAY_STYLES } from '../styles/universal-location-map.styles';

export interface MapSearchOverlayProps {
  provider: any;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onPlaceSelect: (result: AutocompleteResult | null) => void;
  tooltipText?: string;
}

export function MapSearchOverlay({
  provider,
  value,
  placeholder,
  onChange,
  onPlaceSelect,
  tooltipText,
}: MapSearchOverlayProps) {
  return (
    <Box sx={SEARCH_OVERLAY_STYLES}>
      <UniversalAutocompleteField
        provider={provider}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onPlaceSelect={onPlaceSelect}
        tooltipText={tooltipText}
      />
    </Box>
  );
}
